// removed by extract-text-webpack-plugin
module.exports = {"container":"src-styles-components----page-module---container---1Jxc8 src-styles-components----container-module---container---1YJKJ","featuredMedia":"src-styles-components----page-module---featuredMedia---21ix7","pageSection":"src-styles-components----page-module---pageSection---2dwd9"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/page.module.scss
// module id = 397
// module chunks = 163730310732641